/**
 * created by wang lei
 图片转存 页面
 *
 */
import React, {Component} from 'react';
import wordImage from './wordImage.png';

export default class WordImageTool extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <span>
                <img src={wordImage}/>
            </span>
        )
    }

}